import * as appSelectors from 'app/state/app/app-selectors';
import {
  DASHBOARD_INFLIGHT_STATUS,
  DASHBOARD_SUCCESS_STATUS,
} from 'app/state/dashboard/constants';
import * as dashboardSelectors from 'app/state/dashboard/dashboard-selectors';
import { DISABLE_APPLY_FLOW_PATH } from 'common/constants';
import dayjs from 'dayjs';
import isNil from 'lodash/isNil';
import sortBy from 'lodash/sortBy';
import { DataFetchSpinner } from 'pages/portal/dashboard/shared/data-fetch-spinner';
import { NoData } from 'pages/portal/dashboard/shared/no-data';
import pluralize from 'pluralize';
import React, { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { FLOW_PATHS, PORTAL_PATHS } from 'routes/constants';
import { history } from 'routes/history';

import {
  ClickableModuleHeader,
  Module,
  ModuleDataContainer,
  ModuleHeader,
} from '../styles';
import { LicenseDisplay } from './license-display';
import { Button, ButtonContainer, DataFlex } from './styles';

export function TruncatedPermitsList(props) {
  const certificateVerbiage = useSelector(appSelectors.certificateVerbiage);
  const pluralCertificateVerbiage = pluralize(certificateVerbiage);

  const disableApplyFlow = useSelector(
    appSelectors.getFromPortalStats(DISABLE_APPLY_FLOW_PATH),
  );

  const { status: dataFetchStatus, data: userPermitsList } = useSelector(
    dashboardSelectors.userPermitsList,
  );

  const expirationDateSortedLicenses = useMemo(() => {
    if (isNil(userPermitsList)) return [];
    return sortBy(userPermitsList, ({ expirationDate }) =>
      dayjs(expirationDate).unix(),
    );
  }, [userPermitsList]);

  const navigateToApplyFlow = useCallback(() => {
    history.push(FLOW_PATHS.applyStrLicense);
  }, []);

  const openPermitsListView = useCallback(() => {
    history.push(PORTAL_PATHS.dashboardPermitsList);
  }, []);

  return (
    <Module flex={1}>
      <ModuleHeader>
        <ClickableModuleHeader
          disabled={dataFetchStatus === DASHBOARD_INFLIGHT_STATUS}
          onClick={props.fetch}
        >
          {pluralCertificateVerbiage}
          {dataFetchStatus === DASHBOARD_SUCCESS_STATUS &&
            Boolean(expirationDateSortedLicenses.length) &&
            ` (${expirationDateSortedLicenses.length})`}
        </ClickableModuleHeader>

        <DataFetchSpinner
          show={
            dataFetchStatus === DASHBOARD_INFLIGHT_STATUS &&
            Boolean(expirationDateSortedLicenses.length)
          }
        />
      </ModuleHeader>

      <ModuleDataContainer noScrolling>
        <DataFlex>
          {dataFetchStatus !== DASHBOARD_SUCCESS_STATUS ||
          !expirationDateSortedLicenses.length ? (
            <NoData
              onClick={props.fetch}
              disabled={dataFetchStatus === DASHBOARD_INFLIGHT_STATUS}
            >
              {dataFetchStatus === DASHBOARD_SUCCESS_STATUS
                ? `No ${pluralCertificateVerbiage}.`
                : 'Failed to retrieve data. Click to try again.'}
            </NoData>
          ) : (
            <LicenseDisplay licenses={expirationDateSortedLicenses} />
          )}

          <ButtonContainer>
            {!disableApplyFlow && (
              <Button onClick={navigateToApplyFlow}>
                Apply for a new {certificateVerbiage}
              </Button>
            )}

            {!(
              dataFetchStatus !== DASHBOARD_SUCCESS_STATUS &&
              !expirationDateSortedLicenses.length
            ) && (
              <Button onClick={openPermitsListView}>
                See all {pluralCertificateVerbiage}
              </Button>
            )}
          </ButtonContainer>
        </DataFlex>
      </ModuleDataContainer>
    </Module>
  );
}
